import { ReactElement } from "react";
//#region redux
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums, StyleEnums } from "models/enums";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useCloseConfirmation(preventClickOutsideClose?: boolean) {
  const dispatch = useDispatch();

  const showCustomConfirmation = (
    title: string,
    content: ReactElement | string,
    onClose: () => Promise<any>,
    onContinueEditing?: () => Promise<any>
  ) => {
    dispatch(
      displayDialog({
        isOpen: false,
        title: title,
        titleIcon: IconDefinitionConstants.WInfo,
        actions: [
          {
            text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Cancel),
            onClick: onContinueEditing,
            isSecondary: true,
          },
          {
            text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.CloseForm),
            onClick: onClose,
            type: StyleEnums.DisplayType.Info,
          },
        ],
        hideCancelButton: true,
        hideCloseButton: true,
        dialogType: DialogEnums.DialogType.Message,
        children: content,
        type: StyleEnums.DisplayType.Info,
        preventClickOutsideClose: preventClickOutsideClose,
        onClose: onContinueEditing,
      })
    );
  };

  const showConfirmation = (onClose: () => Promise<any>, onContinueEditing?: () => Promise<any>) =>
    showCustomConfirmation(
      LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.FormExitWarningMessage),
      LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.FormExitWarningMessageDescription),
      onClose,
      onContinueEditing
    );

  return { showConfirmation, showCustomConfirmation };
}

export default useCloseConfirmation;
